import endpoints from '../../endpoints';
import { post } from '../requests';

export const saveSalesforceOrder = (params) => {
    return post({ endpoint: endpoints.salesforceOrders.post, params })
}
